function styleToDash(style, dashed) {
  if (style === "dashed" || dashed) {
    return 2;
  }
  if (style === "dotted") {
    return 1;
  }
  return 0;
}
export {
  styleToDash as s
};
